module.exports = 'progressTable'
